if (!customElements.get('td-steps')) {
  class TDSteps extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 1379px)');
      this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.listeners = new AbortController();
      document.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event), {
        signal: this.listeners.signal,
      });
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    // Theme editor: bring the selected step into view via the Embla API
    handleBlockSelect(event) {
      if (!this.mobileQuery.matches) return;

      const blockId = event.detail?.blockId;
      if (!blockId) return;

      const escapedBlockId = typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(blockId) : blockId;
      const slide = this.querySelector(`[data-td-steps-slide][data-td-block-id="${escapedBlockId}"]`);
      const embla = this.querySelector('embla-slider')?.emblaApi;
      if (!(slide instanceof HTMLElement) || !embla || !slide.parentElement) return;

      const index = Array.from(slide.parentElement.children).indexOf(slide);
      if (index >= 0) {
        embla.scrollTo(index, this.reduceMotionQuery.matches);
      }
    }
  }

  customElements.define('td-steps', TDSteps);
}
